function ANRail(parentElement, itemElementHeight, minimumHeightThreshold, marginTop = null, logger = null){

    if(!parentElement || !(parentElement instanceof HTMLElement) || !parentElement.id){ // TODO: Test.

        throw new Error('ANRail: Argument "parentElement" is required and must be an HTMLElement with an ID.');
    }

    if(!itemElementHeight || isNaN(itemElementHeight) || itemElementHeight <= 0){

        throw new Error('ANRail: Arugument "itemElementHeight" is required and must be a positive number.');
    }

    if(!minimumHeightThreshold || isNaN(minimumHeightThreshold) || minimumHeightThreshold <= 0){

        throw new Error('ANRail: Arugument "minimumHeightThreshold" is required and must be a positive number.');
    }

    if(null !== marginTop && (isNaN(marginTop) || marginTop <= 0)){

        throw new Error('ANRail: Arugument "marginTop" must be a positive number or null.');
    }

    this.__parentElement              = parentElement;
    this.__marginTop                  = marginTop || 100;
    this.__elementId                  = `an-rail-${this.__parentElement.id}`;
    this.__lastRecordedHeight         = 0;
    this.__resizeCheckIntervalId      = null;
    this.__itemCount                  = 0;
    this.__currentlyUsedHeight        = 0;
    this.__minimumHeightThreshold     = minimumHeightThreshold;
    this.__itemElementHeight          = itemElementHeight;
    this.__element                    = null;
    this.__resizeObserver             = null;
    this.__zones                      = {};
    this.__itemElements               = {};
    this.__usedShortAdForCalculations = false; 
    this.__locked                     = false;
    // this.__maxItems                   = (location.hostname.indexOf('fextralife.com') !== -1) ? 1 : null; // TODO: Config UI.
    this.__maxItems                   = 1;
    this.__logger                     = logger || new AdsNinjaLogger();

    // Create the rail element.
    railElement              = document.createElement('div');
    railElement.id           = this.__elementId;
    railElement.style.height = '100%';
    // railElement.style.flex      =  '1 auto';   // TODO: Test.
    railElement.classList.add('an-rail');

    this.__element = railElement;

    // Add the rail element to the DOM. 
    this.__parentElement.insertAdjacentElement('beforeend', railElement);
}

//
// Destroy.
ANRail.prototype.destroy = function(){

    if(!this.__resizeObserver){

        return;
    }

    this.__resizeObserver.disconnect();
};

//
// Add rail item.
ANRail.prototype.addItem = function(itemElement, zone){

    var key                  = this.__itemCount;
    this.__itemElements[key] = itemElement;
    this.__zones[key]        = zone;

    this.__itemCount++;
};

//
// Returns the last recorded rail height.
ANRail.prototype.getLastRecordedHeight = function(){

    return this.__lastRecordedHeight;
};

//
// Sets the last recorded rail height.
ANRail.prototype.setLastRecordedHeight = function(value){

    this.__lastRecordedHeight = value;
};

//
// Returns the debug comment.
ANRail.prototype.getDebugComment = function(){

    return `<!-- AdsNinja Rail: Currently using a height of "${this.__currentlyUsedHeight}px" for rail items with the total current rail height being "${this.__lastRecordedHeight}px". Rail items are "${this.__itemElementHeight}px" in height with a margin of "${this.__marginTop}px" between them. -->`;
};

//
// Returns the margin top.
ANRail.prototype.getMarginTop = function(){
    
    return this.__marginTop;
};

//
// Sets the margin top.
ANRail.prototype.setMarginTop = function(value){
    
    this.__marginTop = value;
};

//
// Returns the ad count.
ANRail.prototype.getItemCount = function(){
    
    return this.__itemCount;
}

//
// Retruns the minimum height threshold.
ANRail.prototype.getMinimumHeightThreshold = function(){
    
    return this.__minimumHeightThreshold;
};

//
// Sets the minimum height threshold.
ANRail.prototype.setMinimumHeightThreshold = function(value){
    
    this.__minimumHeightThreshold = value;
};

//
// Returns the currently used height.
ANRail.prototype.getCurrentlyUsedHeight = function(value){
    
    return this.__currentlyUsedHeight;
};

//
// Sets the currently used height.
ANRail.prototype.setCurrentlyUsedHeight = function(value){
    
    this.__currentlyUsedHeight = value;
};

//
// Returns the rail item element height.
ANRail.prototype.getItemElementHeight = function(){
    
    return this.__itemElementHeight;
};

//
// Sets the height used by rail item elements.
ANRail.prototype.setItemElementHeight = function(value){
    
    this.__itemElementHeight = value;
};

//
// Returns the HTML element.
ANRail.prototype.getElement = function(){
    
    return this.__element;
};

//
// Sets the HTML element.
ANRail.prototype.setElement = function(value){
    
    this.__element = value;
};

//
// Monitor resize.
ANRail.prototype.observeResize = function(callback){

    if(typeof ResizeObserver !== 'undefined' && !this.__resizeObserver){

        this.__resizeObserver = new ResizeObserver(callback);
        this.__resizeObserver.observe(document.body);
    }
    else if(typeof ResizeObserver !== 'undefined' && this.__resizeObserver){
        
        this.__resizeObserver.unobserve(document.body);
        this.__resizeObserver.observe(document.body);
    }
    else{
        
        // Warn ResizeObserver is not supported.
        this.__logger.warn('ResizeObserver is not supported. Please update your browser.');

        if(this.__resizeCheckIntervalId){

            clearInterval(this.__resizeCheckIntervalId);
        }

        this.__resizeCheckIntervalId = setInterval(callback, 150000);
    }
};

//
// Stop monitoring resize.
ANRail.prototype.unobserveResize = function(){
    
    if(this.__resizeObserver){

        this.__resizeObserver.unobserve(this.__element);
    }

    if(this.__resizeCheckIntervalId){

        clearInterval(this.__resizeCheckIntervalId);
    }
};

//
// Get last item element.
ANRail.prototype.getLastItemElement = function(){
    
    return this.__itemElements[this.__itemCount - 1];
};

//
// Get need to recalculate.
ANRail.prototype.getUsedShortAdForCalculations = function(){
    
    return this.__usedShortAdForCalculations;
};

//
// Get need to recalculate.
ANRail.prototype.setUsedShortAdForCalculations = function(value){
    
    this.__usedShortAdForCalculations = value;
};

//
// Get max items.
ANRail.prototype.getMaxItems = function(){
    
    return this.__maxItems;
};

//
// Get Lock.
ANRail.prototype.isLocked = function(){
    
    return this.__locked;
};

//
// Lock.
ANRail.prototype.lock = function(value){
    
    this.__locked = value;
};

//
// Unlock.
ANRail.prototype.unlock = function(){
    
    this.__locked = false;
};

window.ANRail = ANRail;